export default __webpack_public_path__ + "static/eu-441e1f6e71dfd81e10e3086eb8fb8fdf.svg";